module.exports = __webpack_public_path__ + "static/media/crystal.fdf8f79.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/crystal.mp3
// module id = QIdb
// module chunks = 82